import { registerLocale, setDefaultLocale } from 'react-datepicker';
import it from 'date-fns/locale/it';

export default function () {
  // Set default locale
  registerLocale('it', it);
  setDefaultLocale('it');
}
